module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot103.feba420e.jpg";